<div class="packlist-details-container">
  <mic-breadcrumb>
    <mic-breadcrumb-link link="/home/dashboard" icon="home" ariaLabel="Home"></mic-breadcrumb-link>
    <mic-breadcrumb-link link="/home/packlists" label="{{ this.translationService.translate('packListsText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ this.translationService.translate('packListDetailsText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <div class="packlist-details-header">
    <h2 class="page-title packlist-details-heading">{{ this.translationService.translate('packListDetailsText') }}</h2>
    <div class="packlist-details-header-actions">
      <button mat-flat-button color="primary" class="btn-export" (click)="openExportModal()" [disabled]="isPdfGenerating">
        @if (isPdfGenerating) {
        <mat-spinner diameter="18" class="button-spinner"></mat-spinner>
        } @else {
        <mat-icon>download</mat-icon>
        }
        {{ this.translationService.translate('exportButtonText') }}
      </button>
      <button id="back-button" mat-flat-button class="btn-cancel" (click)="backNavigation()">
        <mat-icon>arrow_back</mat-icon>
        <span>{{ translationService.translate('backButtonText') }}</span>
      </button>
    </div>
  </div>
  <mat-card>
    <mat-card-content>
      <div class="packlist-details-fields">
        <mat-form-field appearance="fill" class="packlist-details-field" subscriptSizing="dynamic">
          <mat-label>{{ this.translationService.translate('packListNumberText') }}</mat-label>
          <input
            id="packlist-details-number"
            matInput
            [value]="packListNum"
            [attr.aria-label]="translationService.translate('packListNumberText')"
            readonly
          />
        </mat-form-field>
        <mat-form-field appearance="fill" class="packlist-details-field" subscriptSizing="dynamic">
          <mat-label>{{ this.translationService.translate('sourceText') }}</mat-label>
          <input
            id="packlist-details-source"
            matInput
            [value]="source"
            [attr.aria-label]="translationService.translate('sourceText')"
            readonly
          />
        </mat-form-field>
        <mat-form-field appearance="fill" class="packlist-details-field" subscriptSizing="dynamic">
          <mat-label>{{ this.translationService.translate('destinationText') }}</mat-label>
          <input
            id="packlist-details-destination"
            matInput
            [value]="destination"
            [attr.aria-label]="translationService.translate('destinationText')"
            readonly
          />
        </mat-form-field>
        <mat-form-field appearance="fill" class="packlist-details-field" subscriptSizing="dynamic">
          <mat-label>{{ this.translationService.translate('notesText') }}</mat-label>
          <input
            id="packlist-details-notes"
            matInput
            [value]="notes"
            [attr.aria-label]="translationService.translate('notesText')"
            readonly
          />
        </mat-form-field>
      </div>
      <div id="packlist-details-table" class="cam-table btn-table">
        <div class="table-wrapper">
          <mic-table class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
            <ng-container *micTableNoData>
              <mic-empty-state icon="layers_clear" [title]="translationService.translate('emptyTableText')"></mic-empty-state>
            </ng-container>
          </mic-table>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
